// src/screens/yonetim/CariTahsilatScreen.js
import React, { useState, useContext, useRef } from 'react';
import {
  View, Text, StyleSheet, TextInput, FlatList,
  TouchableOpacity, ActivityIndicator, Alert
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { AuthContext } from '../../context/AuthContext';
import CustomAlert from '../../components/CustomAlert';
import CONFIG from '../../config/Config';

const tahsilatKanallari = [
  { id: 3, ad: 'K. KARTI', renk: '#2196F3' },
  { id: 43,  ad: 'NAKİT',    renk: '#4CAF50' },
  { id: 48, ad: 'HAVALE',   renk: '#9C27B0' },
];

const formatTL = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "0,00 ₺";
  return parseFloat(value).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
};

const formatTLKurus = (kurus) => {
  if (!kurus || kurus === 0) return "0,00 ₺";
  return (kurus / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
};

export default function CariTahsilatScreen() {
  const navigation = useNavigation();
  const { userToken } = useContext(AuthContext);
  const userInfo = userToken ? JSON.parse(userToken) : null;

  const [cariler, setCariler]             = useState([]);
  const [isLoading, setIsLoading]         = useState(false);
  const [searchCari, setSearchCari]       = useState('');
  const [seciliCari, setSeciliCari]       = useState(null);
  const [seciliKanal, setSeciliKanal]     = useState(null);
  const [tahsilatTutari, setTahsilatTutari] = useState('');
  const [gercekTutar, setGercekTutar]     = useState(0);
  const kurusRef = useRef(0);

  const [showConfirm, setShowConfirm]     = useState(false);
  const [showError, setShowError]         = useState(false);
  const [errorMsg, setErrorMsg]           = useState('');
  const [showSuccess, setShowSuccess]     = useState(false);

  React.useEffect(() => {
    fetchCariler();
  }, []);

  const fetchCariler = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/cari`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const result = await response.json();
      if (result.success) {
        setCariler(result.data.filter(c => c.AcikHesap === 1 || c.CariBakiye !== 0));
      } else {
        Alert.alert("Uyarı", "Cariler alınamadı: " + result.message);
      }
    } catch {
      Alert.alert("Hata", "Veri çekilemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = ({ nativeEvent }) => {
    const key = nativeEvent.key;
    if (key === 'Backspace') {
      const yeni = Math.floor(kurusRef.current / 10);
      kurusRef.current = yeni;
      setGercekTutar(yeni / 100);
      setTahsilatTutari(yeni === 0 ? '' : formatTLKurus(yeni));
      return;
    }
    if (!/^[0-9]$/.test(key)) return;
    const yeni = kurusRef.current * 10 + parseInt(key, 10);
    kurusRef.current = yeni;
    setGercekTutar(yeni / 100);
    setTahsilatTutari(formatTLKurus(yeni));
  };

  const tahsilatiTamamla = () => {
    if (!gercekTutar || gercekTutar <= 0) { setErrorMsg("Lütfen geçerli bir tutar giriniz!"); setShowError(true); return; }
    if (!seciliKanal) { setErrorMsg("Lütfen bir ödeme yöntemi seçiniz!"); setShowError(true); return; }
    setShowConfirm(true);
  };

  const confirmOdeme = async () => {
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/cari_tahsilat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
        body: JSON.stringify({
          cariID:     seciliCari.CariID,
          tutar:      gercekTutar,
          kanalId:    seciliKanal,
          kasiyerId:  userInfo?.ID || 0,
          kasiyerAdi: userInfo?.Name || 'Bilinmiyor',
        }),
      });
      const result = await response.json();
      if (result.success) {
        setShowConfirm(false);
        setSeciliCari(null);
        setSeciliKanal(null);
        kurusRef.current = 0;
        setGercekTutar(0);
        setTahsilatTutari('');
        setShowSuccess(true);
        fetchCariler();
      } else {
        Alert.alert("Hata", result.message || "İşlem başarısız.");
      }
    } catch {
      Alert.alert("Hata", "Sunucuya bağlanılamadı.");
    }
  };

  const seciliKanalObj = tahsilatKanallari.find(k => k.id === seciliKanal);

  // ── CARİ LİSTESİ ────────────────────────────────────────────
  if (!seciliCari) {
    return (
      <SafeAreaView style={styles.safeArea} edges={['left', 'right']}>
        <TextInput
          style={styles.searchInput}
          placeholder="Cari Ara (İsim)..."
          placeholderTextColor="#95a5a6"
          value={searchCari}
          onChangeText={setSearchCari}
        />

        {isLoading ? (
          <View style={styles.loadingBox}>
            <ActivityIndicator size="large" color="#4CAF50" />
            <Text style={styles.loadingText}>Cariler getiriliyor...</Text>
          </View>
        ) : (
          <FlatList
            style={{ marginBottom: 17 }}
            keyboardShouldPersistTaps="handled"
            data={cariler.filter(c => c.Isim?.toLowerCase().includes(searchCari.toLowerCase()))}
            keyExtractor={item => item.CariID.toString()}
            contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 40 }}
            renderItem={({ item }) => {
              const bakiye      = item.CariBakiye || 0;
              const isAlacakli  = bakiye < 0;
              const renk        = isAlacakli ? '#4CAF50' : bakiye > 0 ? '#E53935' : '#7f8c8d';
              const etiket      = isAlacakli ? 'ALACAKLI' : bakiye > 0 ? 'BORÇLU' : 'TEMİZ';
              return (
                <TouchableOpacity
                  style={styles.cariItem}
                  onPress={() => { setSeciliCari(item); kurusRef.current = 0; setGercekTutar(0); setTahsilatTutari(''); }}
                >
                  <View style={{ flex: 1 }}>
                    <Text style={styles.cariAd} numberOfLines={1}>{item.Isim}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4, gap: 8 }}>
                      <View style={{ backgroundColor: renk, paddingHorizontal: 6, paddingVertical: 2, borderRadius: 4 }}>
                        <Text style={{ color: '#fff', fontSize: 10, fontWeight: 'bold' }}>{etiket}</Text>
                      </View>
                      <Text style={{ color: renk, fontWeight: 'bold', fontSize: 13 }}>{formatTL(Math.abs(bakiye))}</Text>
                    </View>
                  </View>
                  <Ionicons name="chevron-forward" size={20} color="#bdc3c7" />
                </TouchableOpacity>
              );
            }}
            ListEmptyComponent={<Text style={styles.emptyText}>Cari bulunamadı.</Text>}
          />
        )}
      </SafeAreaView>
    );
  }

  // ── TAHSİLAT FORMU ──────────────────────────────────────────
  return (
    <SafeAreaView style={styles.safeArea} edges={['left', 'right', 'bottom']}>
      <View style={styles.formContainer}>

        {/* Seçili Cari Kutusu */}
        <TouchableOpacity style={styles.seciliCariKutu} onPress={() => setSeciliCari(null)}>
          <View style={{ flex: 1 }}>
            <Text style={styles.seciliCariAd} numberOfLines={1}>{seciliCari.Isim}</Text>
            <Text style={styles.seciliCariBakiye}>Mevcut Bakiye: {formatTL(seciliCari.CariBakiye)}</Text>
          </View>
          <Ionicons name="swap-horizontal-outline" size={20} color="#95a5a6" />
        </TouchableOpacity>

        {/* Kanal Seçimi */}
        <Text style={styles.sectionLabel}>ÖDEME YÖNTEMİ</Text>
        <View style={styles.kanalContainer}>
          {tahsilatKanallari.map(kanal => (
            <TouchableOpacity
              key={kanal.id}
              style={[styles.kanalBtn, { borderColor: kanal.renk }, seciliKanal === kanal.id && { backgroundColor: kanal.renk }]}
              onPress={() => setSeciliKanal(kanal.id)}
            >
              <Text style={[styles.kanalText, { color: seciliKanal === kanal.id ? '#fff' : kanal.renk }]}>
                {kanal.ad}
              </Text>
            </TouchableOpacity>
          ))}
        </View>

        {/* Tutar */}
        <Text style={styles.sectionLabel}>TAHSİLAT TUTARI</Text>
        <TextInput
          style={styles.tutarInput}
          keyboardType="numeric"
          placeholder="0,00 ₺"
          placeholderTextColor="#bdc3c7"
          value={tahsilatTutari}
          onKeyPress={handleKeyPress}
          autoFocus
          maxLength={15}
        />

        {/* Onayla */}
        <TouchableOpacity style={styles.onayBtn} onPress={tahsilatiTamamla}>
          <Text style={styles.onayBtnText}>TAHSİLATI TAMAMLA</Text>
        </TouchableOpacity>

      </View>

      {/* Alertler */}
      {showError && (
        <CustomAlert visible={showError} title="Uyarı" message={errorMsg} type="error" confirmText="Tamam" onConfirm={() => setShowError(false)} />
      )}
      {showConfirm && seciliCari && seciliKanal && (
        <CustomAlert
          visible={showConfirm}
          title="Ödeme Onayı"
          message={
            <Text style={{ textAlign: 'center', lineHeight: 45 }}>
              <Text style={{ fontWeight: '400' }}>Cari: </Text>
              <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{seciliCari.Isim}</Text>
              {"\n"}
              <Text style={{ fontWeight: '400' }}>Tutar: </Text>
              <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{tahsilatTutari}</Text>
              {"\n"}
              <Text style={{ fontWeight: 'bold', fontSize: 30, color: seciliKanalObj?.renk }}>
                {seciliKanalObj?.ad}
              </Text>
            </Text>
          }
          type="warning" confirmText="Onayla" cancelText="İptal" showCancel
          onConfirm={confirmOdeme}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      {showSuccess && (
        <CustomAlert
          visible={showSuccess} title="Başarılı" message="Tahsilat başarıyla kaydedildi."
          type="success" confirmText="Tamam"
          onConfirm={() => { setShowSuccess(false); navigation.goBack(); }}
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea:        { flex: 1, backgroundColor: '#F5F7FA' },
  searchInput:     { margin: 16, backgroundColor: '#fff', borderRadius: 12, padding: 12, fontSize: 15, color: '#2c3e50', borderWidth: 1, borderColor: '#e9ecef' },
  loadingBox:      { flex: 1, justifyContent: 'center', alignItems: 'center' },
  loadingText:     { marginTop: 10, color: '#7f8c8d', fontSize: 15 },
  cariItem:        { flexDirection: 'row', alignItems: 'center', paddingVertical: 14, borderBottomWidth: 1, borderBottomColor: '#ecf0f1' },
  cariAd:          { fontSize: 16, fontWeight: '600', color: '#34495e' },
  emptyText:       { textAlign: 'center', color: '#95a5a6', marginTop: 40, fontSize: 15 },
  formContainer:   { flex: 1, padding: 16 },
  seciliCariKutu:  { flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff', borderRadius: 12, padding: 16, marginBottom: 24, borderWidth: 1, borderColor: '#e9ecef', elevation: 2 },
  seciliCariAd:    { fontSize: 17, fontWeight: 'bold', color: '#2c3e50', marginBottom: 4 },
  seciliCariBakiye:{ fontSize: 14, color: '#e74c3c' },
  sectionLabel:    { fontSize: 11, fontWeight: '700', color: '#95a5a6', letterSpacing: 1, marginBottom: 10 },
  kanalContainer:  { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 24 },
  kanalBtn:        { flex: 1, borderWidth: 2, borderRadius: 10, paddingVertical: 12, marginHorizontal: 4, alignItems: 'center', backgroundColor: '#fff' },
  kanalText:       { fontSize: 13, fontWeight: 'bold' },
  tutarInput:      { backgroundColor: '#fff', borderWidth: 1, borderColor: '#bdc3c7', borderRadius: 12, padding: 16, fontSize: 28, fontWeight: 'bold', color: '#2c3e50', textAlign: 'center', marginBottom: 30 },
  onayBtn:         { backgroundColor: '#4CAF50', borderRadius: 14, paddingVertical: 16, alignItems: 'center' },
  onayBtnText:     { color: '#fff', fontSize: 16, fontWeight: '800', letterSpacing: 0.5 },
});